module.exports = {
	"author": "DigixGlobal",
	"title": "Owner based access control",
	"fileName": "contracts/ACOwned.sol",
	"name": "ACOwned",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"type": "function"
		}
	],
	"bin": "606060405234610000575b60da806100186000396000f30060606040526000357c0100000000000000000000000000000000000000000000000000000000900463ffffffff1680638da5cb5b14603c575b6000565b3460005760466088565b604051808273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200191505060405180910390f35b600060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff16815600a165627a7a72305820c675fdfdadc2d546351b4bdeadc26d486f045ec6b38f6ad22e655c1ff6ece98c0029",
	"opcodes": "PUSH1 0x60 PUSH1 0x40 MSTORE CALLVALUE PUSH2 0x0 JUMPI JUMPDEST PUSH1 0xDA DUP1 PUSH2 0x18 PUSH1 0x0 CODECOPY PUSH1 0x0 RETURN STOP PUSH1 0x60 PUSH1 0x40 MSTORE PUSH1 0x0 CALLDATALOAD PUSH29 0x100000000000000000000000000000000000000000000000000000000 SWAP1 DIV PUSH4 0xFFFFFFFF AND DUP1 PUSH4 0x8DA5CB5B EQ PUSH1 0x3C JUMPI JUMPDEST PUSH1 0x0 JUMP JUMPDEST CALLVALUE PUSH1 0x0 JUMPI PUSH1 0x46 PUSH1 0x88 JUMP JUMPDEST PUSH1 0x40 MLOAD DUP1 DUP3 PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND DUP2 MSTORE PUSH1 0x20 ADD SWAP2 POP POP PUSH1 0x40 MLOAD DUP1 SWAP2 SUB SWAP1 RETURN JUMPDEST PUSH1 0x0 PUSH1 0x0 SWAP1 SLOAD SWAP1 PUSH2 0x100 EXP SWAP1 DIV PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND DUP2 JUMP STOP LOG1 PUSH6 0x627A7A723058 SHA3 0xc6 PUSH22 0xFDFDADC2D546351B4BDEADC26D486F045EC6B38F6AD2 0x2e PUSH6 0x5C1FF6ECE98C STOP 0x29 ",
	"source": "pragma solidity ^0.4.6;\n\n/// @title Owner based access control\n/// @author DigixGlobal\n\ncontract ACOwned {\n\n    address public owner;\n    \n    /// @dev Modifier to check if msg.sender is the contract owner\n    modifier ifOwner() {\n        if (owner != msg.sender) {\n            throw;\n        } else {\n            _;\n        }\n    }\n\n}\n",
	"abiDocs": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"type": "function",
			"signature": "owner()",
			"signatureHash": "8da5cb5b"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./docs/ACOwned.json
// module id = 1068
// module chunks = 0